import './App.css';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import Home from './pages/Home';
import Privacy from './pages/Privacy';
import NotFound from './pages/NotFound';
import PrivacyControls from './components/privacy/PrivacyControls';
import PageMetadata from './components/routing/PageMetadata';
import PageAnalytics from './components/routing/PageAnalytics';
import GuestSpeakerEvent from './pages/GuestSpeakerEvent';
import PublicSpeaking from './pages/PublicSpeaking';
import AcademicChangemaker from './pages/AcademicChangemaker';
import DeliverySystemCaseStudy from './pages/DeliverySystemCaseStudy';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // For route changes, scroll to top instantly without smooth behavior
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant'
    });
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <div className="App">
        <ScrollToTop />
        <PageMetadata />
        <PageAnalytics />
        <PrivacyControls />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/guest-speaker-event" element={<GuestSpeakerEvent />} />
          <Route path="/academic-changemaker-recognition" element={<AcademicChangemaker />} />
          <Route path="/delivery-system-case-study" element={<DeliverySystemCaseStudy />} />
          <Route path="/public-speaking" element={<PublicSpeaking />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
